import { render, staticRenderFns } from "./ConnectModal.vue?vue&type=template&id=132e049c"
import script from "./ConnectModal.vue?vue&type=script&lang=js"
export * from "./ConnectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports